<template>
  <div class="card pa-20">
    <section class="card-content px-0">
      <selecteur-point-de-vente
        :societe-id="societeId"
        :ids-exclus="idsExclusPdv"
        @select="onSelect"/>
    </section>
    <section class="card-content px-0 pt-0">
      <div class="columns">
        <div class="column">
          <p class="has-text-grid-1 is-size-14px has-text-weight-bold mb-5">
            {{ $t('tableauDeBord.listeRecom.copiePdv.actuel') }}
          </p>
          <bloc-info-tiers
            v-if="infosAncien"
            :pdv="infosAncien.pdv"
            :enseigne="infosAncien.enseigne"/>
        </div>
        <div class="column">
          <p class="has-text-grid-1 is-size-14px has-text-weight-bold mb-5">
            {{ $t('tableauDeBord.listeRecom.copiePdv.nouveau') }}
          </p>
          <b-skeleton v-if="chargementNouveau" :count="3"/>
          <bloc-info-tiers
            v-else-if="infosNouveau"
            :pdv="infosNouveau.pdv"
            :enseigne="infosNouveau.enseigne"/>
          <p v-else class="is-size-7 has-text-default is-italic">
            {{ $t('tableauDeBord.listeRecom.copiePdv.aucunPdv') }}
          </p>
        </div>
      </div>
    </section>
    <footer class="has-text-centered mt-10">
      <b-button
        type="is-transparent"
        class="has-text-default"
        @click="$emit('termine')">
        {{ $t('tableauDeBord.listeRecom.copiePdv.annuler') }}
      </b-button>
      <b-button
        type="is-primary"
        class="has-text-weight-bold ml-20"
        :disabled="!infosNouveau"
        @click="confirmer">
        {{ $t('tableauDeBord.listeRecom.copiePdv.copier') }}
      </b-button>
    </footer>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { browseDetailClient } from '@/api/clients/index';
import getAdressFullString from '@/services/general/getAdressFullString';
import getLogoClient from '@/services/general/getLogoClient';
import gestionErreur from '@/services/general/gestionErreur';
import enrichirPointDeVente from '@/services/recommandation/enrichirPointDeVente';
import SelecteurPointDeVente from '@/components/recommandation/SelecteurPointDeVente';
import BlocInfoTiers from '@/components/recommandation/BlocInfoTiers';
import changerPointDeVenteRecommandation from '@/services/recommandation/changerPointDeVenteRecommandation';

const Recommandations = createNamespacedHelpers('recommandations');

function infoTiers(tiers) {
  if (!tiers) return null;
  return {
    nom: tiers.nomCommercial,
    logo: tiers.urlLogo || tiers.srcImg || null,
    adresse: getAdressFullString(tiers.adressePostale || {}),
  };
}

export default {
  name: 'ModalCopiePointDeVente',
  components: {
    SelecteurPointDeVente,
    BlocInfoTiers,
  },
  data() {
    return {
      infosAncien: null,
      infosNouveau: null,
      chargementNouveau: false,
      pointDeVenteChoisi: null,
    };
  },
  computed: {
    ...Recommandations.mapGetters({
      recommandationCourante: 'recommandation',
      pointDeVenteCourant: 'pointDeVente',
    }),
    societeId() {
      return this.recommandationCourante ? this.recommandationCourante.societeId : null;
    },
    idsExclusPdv() {
      return this.pointDeVenteCourant ? [this.pointDeVenteCourant.id] : [];
    },
  },
  methods: {
    async onSelect(client) {
      if (!client) {
        this.pointDeVenteChoisi = null;
        this.infosNouveau = null;
        return;
      }
      this.pointDeVenteChoisi = client;
      this.infosNouveau = null;
      this.chargementNouveau = true;
      try {
        const [pdvEnrichi, enseigneResponse] = await Promise.all([
          enrichirPointDeVente(client),
          client.tiersParentId ? browseDetailClient(client.tiersParentId) : Promise.resolve(null),
        ]);
        let enseigne = null;
        if (enseigneResponse && enseigneResponse.data) {
          const logo = (await getLogoClient(enseigneResponse.data)).logo;
          enseigne = {
            nom: enseigneResponse.data.nomCommercial,
            logo: logo && logo.chemin ? logo.chemin : null,
            adresse: getAdressFullString(enseigneResponse.data.adressePostale || {}),
          };
        }
        this.infosNouveau = {
          pdv: {
            nom: pdvEnrichi.nomCommercial,
            logo: pdvEnrichi.urlLogo || null,
            adresse: client.adresse || getAdressFullString(pdvEnrichi.adressePostale || {}),
          },
          enseigne,
        };
      } catch (error) {
        gestionErreur('Erreur lors du chargement des informations du point de vente', error);
        throw error;
      } finally {
        this.chargementNouveau = false;
      }
    },
    async confirmer() {
      if (!this.pointDeVenteChoisi) {
        this.$emit('termine');
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        await changerPointDeVenteRecommandation(this.pointDeVenteChoisi);
        this.$emit('termine');
      } catch (error) {
        gestionErreur('Erreur lors du changement de point de vente de la copie', error);
      } finally {
        loadingComponent.close();
      }
    },
  },
  mounted() {
    this.infosAncien = this.pointDeVenteCourant ? {
      pdv: infoTiers(this.pointDeVenteCourant),
      enseigne: infoTiers(this.pointDeVenteCourant.tiersParent),
    } : null;
  },
};
</script>
